import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import StatementGrid, {
  StatementGridInternal,
} from "../../components/grids/StatementGrid";
// import { getMe } from '../../CroActions';
import { isInternal } from "../../CroUtils";
import Bugsnag from "../../../../utils/bugsnag";
import {deleteStatement, downloadStatementDigitalActCertificate} from "../../CroActions";
import Dialog from "material-ui/Dialog";
import Button from "../../../../components/form/Button";


class Statements extends Component {
  // state = {
  //   judge: false,
  // }

  state = {
    deleteDialogOpen: false,
    statementIdToDelete: null,
  };

  /*async*/ componentWillMount() {
    const { breadcrumbs /*dispatch*/ } = this.props;
    breadcrumbs([{ label: "Oznámení" }]);

    // const official = await getMe(dispatch);
    // try {
    //   this.setState({ judge: official.judge });
    // }
    // catch (error) {
    //   Bugsnag.notify('Statements grid error - setState (judge)', error.message);
    // }
  }

  onAdd = (url) => () => this.props.push(`${url}/oznameni/form`);
  onRowClick =
    (url) =>
    ({ id }) =>
      this.props.push(`${url}/oznameni/form/${id}`);

  openDeleteDialog = (id) => {
    this.setState({ deleteDialogOpen: true, statementIdToDelete: id });
  };

  closeDeleteDialog = () => {
    this.setState({ deleteDialogOpen: false, statementIdToDelete: null });
  };

  confirmDelete = async () => {
    const { statementIdToDelete } = this.state;
    if (statementIdToDelete) {
      await this.props.deleteStatement(statementIdToDelete);
      window.location.reload();
    }
  };

  onUseAsTemplate = (statement) => {
    const { auth, dispatch } = this.props;

    if(!statement.useAsTemplateDisabled) {
      dispatch(push({pathname: `${auth.startUrl}/oznameni/form/${statement.id}/kopie`, state: {cloneStatement: true}}));
    }
  };

  downloadDigitalActCertificate = async (statementId) => {
    const { auth, dispatch } = this.props;

    await downloadStatementDigitalActCertificate(auth, statementId, dispatch);
  }

  render() {
    // if (this.state.judge) {
    //   return <div>---</div>;
    // }

    const { auth } = this.props;
    const { deleteDialogOpen, items } = this.state;
    const GridComponent = isInternal(auth)
      ? StatementGridInternal
      : StatementGrid;

    const dialogActions = [
      <Button
          label="Zrušit"
          onClick={this.closeDeleteDialog}
          style={{ marginRight: 8 }}
      />,
      <Button
          label="Smazat"
          onClick={this.confirmDelete}
      />,
    ];

    try {
      return ( 
          <div>
            <GridComponent
              gridName="statementsGrid"
              url={`${auth.startUrl}/api/oznameni`}
              items={this.items}
              adding={true}
              onAdd={this.onAdd(auth.startUrl)}
              onRowClick={this.onRowClick(auth.startUrl)}
              onDelete={this.openDeleteDialog}
              onUseAsTemplate={this.onUseAsTemplate}
              push={this.props.push}
              auth={auth}
              downloadDigitalActCertificate={this.downloadDigitalActCertificate}
            />
            <Dialog
              title="Smazat oznámení"
              actions={dialogActions}
              modal={false}
              open={deleteDialogOpen}
              onRequestClose={this.closeDeleteDialog}
              contentStyle={{ maxWidth: 480 }}
              paperProps={{ style: { borderRadius: 12 } }}
            >
              Opravdu si přejete smazat toto oznámení?
            </Dialog>
          </div>
      );
    } catch (error) {
      Bugsnag.notify("Statements grid error", error.message);
    }
  }
}

export default connect(null, { breadcrumbs, push, deleteStatement })(Statements);
